import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";

import { useJsonApi } from "@/modules/api/hooks/useJsonApi";
import { queryKeys } from "@/modules/api/queryKeys";
import { useAuthContext } from "@/modules/auth/hooks/useAuthContext";
import {
  getHandbookQuery,
  GetHandbookResponse,
} from "@/modules/handbooks/api/queries/getHandbookQuery";
import { notify } from "@/modules/notify/notify";

const translationNamespace = "pages/HandbooksPage";

const serializeHandbook = (
  fetchedHandbook: GetHandbookResponse["included"]
) => {
  return {
    url: fetchedHandbook[0].attributes.url,
  };
};

export function useGetHandbookLinkQuery(handbookId: string) {
  const jsonApi = useJsonApi();
  const { userCompanyId } = useAuthContext();
  const { t } = useTranslation(translationNamespace);

  return useQuery(
    userCompanyId && handbookId
      ? {
          queryKey: [
            queryKeys.handbooks.getHandbookLink,
            handbookId,
            userCompanyId,
          ],
          queryFn: () =>
            getHandbookQuery(jsonApi, {
              companyId: userCompanyId,
              handbookId,
            }),
          select: (response) => {
            if (response) {
              return serializeHandbook(response.included);
            }
          },
          onError: () => {
            notify.alert.error(t("Something went wrong..."));
          },
          retry: false,
          refetchOnWindowFocus: false,
          enabled: false,
        }
      : { enabled: false }
  );
}
